import * as React from "react";
import {
  PhoneInput as BasePhoneInput,
  COUNTRIES,
  PhoneInputProps,
} from "baseui/phone-input";

import { getInputOverrides } from "./Input";

export function PhoneInput(props: PhoneInputProps) {
  const { value = {}, onChange, ...restProps } = props;
  const { country = COUNTRIES.AU, text } = value as TODO;

  function handleCountryChange({ option }) {
    onChange?.({
      ...value,
      country: option,
    });
  }

  function handleTextChange(event) {
    onChange?.({
      ...value,
      text: event.currentTarget.value,
    });
  }
  const inputOverrides = getInputOverrides({
    size: restProps.size,
    color: restProps.color,
    type: "phone",
  });

  return (
    <BasePhoneInput
      overrides={{
        Input: {
          props: {
            overrides: {
              Root: {
                ...inputOverrides.Root,
              },
              Input: {
                style: {
                  minWidth: 0, // firefox default min width fix
                },
              },
              InputContainer: {
                style: {
                  backgroundColor: "transparent",
                },
              },
            },
          },
        },
        CountryPicker: {
          props: {
            overrides: {
              ControlContainer: {
                style: {
                  backgroundColor: "transparent",
                  paddingLeft: 0,
                  paddingRight: "10px",
                },
              },
            },
          },
        },
        DialCode: {
          style: {
            marginLeft: 0,
            marginRight: "8px",
          },
        },
      }}
      country={country}
      text={text}
      onCountryChange={handleCountryChange}
      onTextChange={handleTextChange}
      {...restProps}
    />
  );
}
